<template>
  <el-drawer
    :data-id="dataId || id"
    ref="drawer"
    append-to-body
    :withHeader="showHeader && !!modalTitle"
    :title="modalTitle"
    :size="size"
    :visible.sync="isThisModalOpen"
    :direction="direction"
    :show-close="showClose"
    :wrapperClosable="!isCloseHandlerCalculated"
    :close-on-press-escape="true"
    :before-close="handleClose"
    :destroy-on-close='destroyOnClose'
    @closed="$emit('modal-closed')"
    @opened="$emit('modal-opened')"
  >
    <template slot="title" class="new-modal-header" v-if="showHeader">
      <h4 class="modal-title">{{ $i18n.t(modalTitle) }}</h4>
      <slot name="title-buttons"></slot>
    </template>
    <div :class="modalClasses">
      <div :class="modalBodyClasses">
        <slot></slot>
        <p v-if="isConfirm">{{ $i18n.t('are_you_sure') }}</p>
      </div>
      <div class="new-modal-footer">
        <slot name="before-footer" />
        <slot name="footer">
          <slot name="buttons" />
          <button v-if="isConfirm" type="button" class="el-button el-button--primary" @click="onConfirm">
            <i></i>
            {{ $i18n.t('modal_confirm') }}
          </button>
        </slot>
        <slot name="after-footer" />
      </div>
    </div>
  </el-drawer>
</template>

<script>
/**
 * @param Modal
 *
 * @description Az oldalakon a felugró ablakok megjelenítése
 */
import { mapActions, mapGetters } from 'vuex'
import FormDataVersion from '../form-version/FormDataVersion'
import { get } from 'lodash'

export default {
  name: 'modal',
  components: {
    FormDataVersion,
  },
  props: {
    modalCloseHandler: {
      type: String,
      default: 'calculated'
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: '50%',
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    isPopup: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    direction: {
      type: String,
      default: 'rtl',
    },
    id: {
      type: String,
      default: `modal-${Date.now()}`,
    },
    dataId: {
      type: String,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
    dirty: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listenerActive: false,
    }
  },
  beforeMount() {
    this.addModal({ id: this.id, isOpen: this.isOpen })
  },
  methods: {
    ...mapActions(['hideModal', 'addModal']),
    async handleClose(event) {
      if (this.isPopup) {
        this.$emit('dynform-close')
      } else {
        let confirmation = null
        if (this.dirty) {
          confirmation = await this.$confirm(this.$i18n.t('you_have_unfinished_changes'))
        } else {
          this.hideModal(this.id)
        }
        if (confirmation) {
          this.hideModal(this.id)
        }
      }
    },
    handleMousedown(area, event) {
      if (event.clientX < area.x) {
        this.handleClose()
      }
    },
    onConfirm() {
      this.$emit('on-confirm-status', true)
      this.hideModal(this.id)
    },
  },
  computed: {
    ...mapGetters(['openModals']),
    modalBodyClasses(){
      return {
        'new-modal-body': true,
        'h-100': this.fullHeight
      }
    },
    modalClasses() {
      return {
        'new-modal-content': true,
        'h-100': this.fullHeight
      }
    },
    isPopupOpen() {
      return !!this.openModals.find((modal) => modal.id === this.id)
    },
    isThisModalOpen: {
      get() {
        return this.isPopupOpen || this.isOpen
      },
      set(value) {},
    },
    modalTitle() {
      return get(
        this.openModals.find((modal) => modal.id === this.id),
        'modalParams.title',
        this.title,
      )
    },
    isCloseHandlerCalculated() {
      return this.modalCloseHandler === 'calculated'
    }
  },
  watch: {
    isPopupOpen: {
      handler() {
        if (this.isCloseHandlerCalculated && !this.listenerActive) {
          this.$nextTick(() => {
            const wrapper = this.$refs['drawer'].$el
            const parent = wrapper.querySelector('.el-drawer__container.el-drawer__open')
            const drawer = wrapper.querySelector('.el-drawer__container.el-drawer__open > div')
            if (drawer) {
              this.listenerActive = true
              const drawerArea = drawer.getBoundingClientRect()
              parent.addEventListener('mousedown', (event) => this.handleMousedown(drawerArea, event))
            }
          })
        }
      },
    },
  },
}
</script>

<style lang="scss">
.el-drawer {
  .el-drawer__header {
    background-color: $light1;
    margin: 0 !important;
    padding: 20px !important;
    flex-direction: row !important;
  }
  .modal-title {
    color: $color-text-regular;
    font-weight: 600;
    font-size: 18px;
  }
  .new-modal-footer {
    bottom: 0;
    left: 0;
    position: absolute;
    padding: 10px;
    text-align: right;
    width: 100%;
  }
  .new-modal-body {
    padding: 20px;
    margin-bottom: 50px;
  }
}
</style>
